window.loadScheduler.onDomContentLoaded(function() {
  // WeTheme bug workaround: on browser back/forward navigation, scroll_position_history()
  // restores .pagination innerHTML from sessionStorage *after* initialize() attaches the
  // click handler, creating a new DOM node that has no handler. Fix: clear the stored
  // pagination entry so the subsequent cd re-init (via 'paginate') doesn't overwrite again.
  (function() {
    var navType = performance.navigation ? performance.navigation.type
      : (performance.getEntriesByType('navigation')[0] || {}).type;
    var isBackForward = navType === 2 || navType === 'back_forward';
    if (!isBackForward) return;
    var paginationKey = 'pagePagination_' + document.location.pathname;
    if (!sessionStorage.getItem(paginationKey)) return;
    sessionStorage.removeItem(paginationKey);
    document.dispatchEvent(new CustomEvent('paginate'));
  })();

  let collectionContainer = document.querySelector('body');

  // collectionContainer.addEventListener('click', function(e){
  //   let addClicked = e.target.closest('.Btn--gray:not(.customqty-addcart)');
  //   if(!addClicked) return;
  //   let variantId = addClicked.dataset.variantId;
  //   let qty = addClicked.dataset.qty;
  //   customaddToCart(variantId,qty,addClicked)

  // })

  // collectionContainer.addEventListener('click', function(e){
  //   let addClicked = e.target.closest('.customqty-addcart');
  //   if(!addClicked) return;

  //   let variantId = addClicked.dataset.variantId;
  //   let qty = addClicked.previousElementSibling.value;
  //   customaddToCart(variantId,qty,addClicked);

  // })
   
  jQuery(document).on('click','.qty-btnopen', function(e){
  	e.preventDefault();
    jQuery(this).parent('.btn_parent_div').find('.QuickcQty').show();
  	jQuery('.Underlay').show();
})

jQuery('.Underlay').on('click', function(){
    jQuery('.QuickcQty').hide();
  	jQuery('.Underlay').hide();
})


// function customaddToCart(vid, qty, ele){
// 	    var pro_data = {
// 		    'quantity': qty,
// 		    'id': vid
// 		  }
//         var originalval = ele.innerHTML;
//        ele.innerHTML  = 'Added to cart';
        
//        $.ajax({
//           type: 'POST', 
//           url: '/cart/add.js',
//           dataType: 'json', 
//           data: pro_data,
//           success: function(){
//             setTimeout(function () {
//                 ele.innerHTML  = originalval;
//             }.bind(this), 1000);
            
//              jQuery.getJSON('/cart.js', function(cart) {
//                	 let cartcount = parseInt(cart.item_count);
//                	 jQuery('.cart-item-count-header--quantity').html(cartcount);
//              });
            
            
//           },
         
//      });
  
// }
  // customaddToCart(41190503481528, 1, this);

 //   function positiveNumericInput(el)
 //  {
 //    nb=el.value;
 //    el.value = nb;
 //    jQuery('.FormItem-cnumber').val(nb);
 //    if(isNaN(nb) || nb<1)
 //    {
 //      el.value=1;
 //      jQuery('.FormItem-cnumber').val(1);
 //    }
 //  }
 
 // function positiveNumericInput2(el)
 // {
 //    nb=Number(el.value);
 //    el.value = nb;
 //    nb = (nb%2!=0)? nb+1: nb;
 //    console.log('nb-',nb);
 //    jQuery('.FormItem-cnumber').val(nb);
 //    if(isNaN(nb) || nb<1)
 //    {
 //      el.value=2;
 //      jQuery('.FormItem-cnumber').val(1);
 //    }
 // }


  // landscape mode js
  collectionContainer.addEventListener('click', function(e){
    let landscape = e.target.closest('.landscape');
    let miniBox = e.target.closest('.mini-box');
    if(!landscape && !miniBox) return;
    // Re-query on every click instead of caching once at DOMContentLoaded: AJAX
    // filtering/pagination (assets/filtering.js renderProductGrid) replaces the
    // grid's innerHTML, which detaches the originally-captured NodeList and makes
    // this toggle silently stop affecting the visible grid after a filter change.
    let allgrid__item = document.querySelectorAll('.collection-main-body-inner .grid__item');
    if(landscape){
      allgrid__item.forEach((collection) =>{
      let img = collection.querySelector('.grid-view-item-image');
      let landingscaping = collection.querySelectorAll('.landingscaping');
      collection.style.width = '100%';
      img.classList.add('landingscaping-img');
      landingscaping.forEach(ele => {
        ele.classList.add('landingscaping-elements');
      })
    })
    }else if(miniBox){
      allgrid__item.forEach((collection) =>{
      let img = collection.querySelector('.grid-view-item-image');
      let landingscaping = collection.querySelectorAll('.landingscaping');
      collection.style.width = '32%';
      img.classList.remove('landingscaping-img');
      landingscaping.forEach(ele => {
        ele.classList.remove('landingscaping-elements');
      })
    })
    }

    
    
  })
  
});



